<template>
    <div class="mt-2 flex h-6 flex-nowrap items-center justify-center gap-x-4">
        <button v-for="(_, i) in Array(slidesCount)"
                :key="i"
                :aria-label="`Navigate to slide ${i + 1}`"
                class="size-3 rounded-full bg-primary ring-0 ring-accent/70 transition-all"
                :class="{ 'size-4 ring-2': i === currentSlide }"
                @click="slideTo(i)" />
    </div>
</template>

<script setup lang="ts">
defineOptions({
    name: 'Pagination'
})

interface Props {
    slidesCount: number
    currentSlide?: number
    slideTo?: (slideIndex: number) => void
}

withDefaults(defineProps<Props>(), {
    currentSlide: 0,
    slideTo: () => {}
})
</script>
